@if (link) {
  @if (externalLink) {
    <a
      [href]="link"
      [class]="{
        link: true,
        'full-width': fullWidth,
      }"
      target="_blank"
    >
      <ng-container *ngTemplateOutlet="buttonTemp" />
    </a>
  } @else {
    <a
      [routerLink]="link"
      [class]="{
        link: true,
        'full-width': fullWidth,
      }"
      [queryParams]="query"
    >
      <ng-container *ngTemplateOutlet="buttonTemp" />
    </a>
  }
} @else {
  <ng-container *ngTemplateOutlet="buttonTemp" />
}

<ng-template #buttonTemp>
  <button
    [class]="{
      button: true,
      'full-width': fullWidth,
      'size-large': size === 'large',
      'size-medium': size === 'medium',
      'primary-contained': variant === 'primary-contained',
      'secondary-contained': variant === 'secondary-contained',
      'error-link': variant === 'error-link',
      outlined: variant === 'outlined',
      link: variant === 'link',
    }"
    (click)="handleClick()"
    [type]="type"
    [disabled]="disabled || loading"
  >
    @if (startIcon && !loading) {
      @if (imageIcon) {
        <img [src]="startIcon" class="start-icon image-icon" />
      } @else {
        <i [class]="'start-icon isax-outlined isax-outlined-' + startIcon"></i>
      }
    }
    @if (loading) {
      <app-loading-spinner class="start-icon" [Size]="16" />
    }
    <span class="label">{{ label }}</span>
    @if (endIcon) {
      <i [class]="'end-icon isax-outlined isax-outlined-' + endIcon"></i>
    }
  </button>
</ng-template>
